module.exports = __webpack_public_path__ + "static/img/image_home_product_03.d86eee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_product_03.png
// module id = v7kh
// module chunks = 10